// extracted by mini-css-extract-plugin
module.exports = {"title":"Documents_title__1UWZR","selects":"Documents_selects__gUMzj"};